import TermList from "../AdminTermList";

export default class AdminTermListNotificationType extends TermList {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "notification_type";
  }
}
